import { type Enum } from '@webapp/infrastructure/types/Enum'

export interface MarketoServiceConfig {
  baseUrl: string | undefined
  munchkinId: string | undefined
  formId: string | undefined
}

// Valid values for the Marketo `inAppExpansionRequestType` picklist. Marketo
// stores this field as a constrained option set, so callers must use one of
// these values. Also the canonical `feature` value shared with FullStory so
// leads reconcile (PAY-4559).
export const FeatureExpansionRequestTypes = {
  GUIDED_INTAKE: 'Guided Intake',
  AP: 'AP',
  CONTRACTS: 'Contracts',
  CUSTOM_FIELDS: 'Custom Fields',
  BILL_PAY: 'Bill Pay',
} as const

export type FeatureExpansionRequestType = Enum<
  typeof FeatureExpansionRequestTypes
>

export interface MarketoFormContext {
  firstName?: string
  lastName?: string
  email?: string
  domain?: string
  // Typed as string[] (not PermissionEnum[]) to keep the core layer free of a
  // platform/iam dependency. PermissionEnum is a string union, so callers in
  // higher layers can pass PermissionEnum[] directly.
  permissions?: string[]
  // Maps to the Marketo `inAppExpansionRequestType` picklist, which only accepts
  // a fixed set of values.
  context?: FeatureExpansionRequestType
}

interface MktoForm {
  setValues(values: Record<string, string>): void
  submit(): void
  onSuccess(callback: () => boolean): void
}

export interface MktoForms2 {
  loadForm(
    baseUrl: string,
    munchkinId: string,
    formId: number,
    callback?: (form: MktoForm | null) => void
  ): void
}

declare global {
  interface Window {
    MktoForms2?: MktoForms2
  }
}
